import styled from "styled-components";

const DeliveryItemsGridStyled = styled.div`
    width: 100%;
`;

const DeliveryItemsGridWrapperStyled = styled.div`
    > .cta-link {
        margin: 1.6rem;
        display: inline-block;

        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            margin: 1.6rem 3.2rem;
        }
    }
`;

const DeliveryItemsGridHeadersStyled = styled.div`
    display: none;
    font-weight: 700;
    font-size: 1.3rem;
    border-bottom: 1px solid #cfd0cf;

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        font-size: 1.4rem;
        padding: 1.6rem 3.2rem;
        display: flex;

        > div {
            flex: 2;

            &:first-of-type {
                width: 12rem;
                flex: initial;
                margin-right: 1.6rem;
            }

            &:last-of-type {
                flex: 4;
            }
        }
    }
`;

const DeliveryItemsLinkStyled = styled.div`
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    @media only screen and (max-width: ${props => props.theme.upToSmallDesktop}) {
        flex-direction: column;
        border-bottom: 1px solid ${props => props.theme.mintGreen};

        &:nth-of-type(even) {
            background-color: ${props => (props.isBusiness ? "#FAFFFE" : "#FAFFF5")};
        }
    }

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        padding: 1.6rem 3.2rem;
        border-bottom: 1px solid #cfd0cf;

        &:nth-of-type(even) {
            background-color: ${props => (props.isBusiness ? "#FAFFFE" : "#FAFFF5")};
        }

        .mobileHeading {
            display: none;
        }

        &:last-of-type {
            border-bottom: none;
        }
    }

    .subTitle {
        font-size: 1.4rem;
    }

    .orderNumber {
        font-size: 1.6rem;
        font-weight: 700;

        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            font-size: 2rem;
        }
    }

    .listCta {
        font-size: 1.4rem;

        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            font-size: 1.6rem;
            text-align: right;
        }
    }
`;

const DeliveryItemsColStyled = styled.div`
    font-weight: 700;
    flex: 2;

    @media only screen and (max-width: ${props => props.theme.upToSmallDesktop}) {
        .mobileHeading {
            flex: 1;
        }

        > div:not(.mobileHeading) {
            flex: 2;
            text-align: left;
        }

        border-bottom: 1px solid ${props => props.theme.lightGray};

        &:last-child {
            border-bottom: none;
        }
    }

    @media only screen and (max-width: ${props => props.theme.upToSmallDesktop}) {
        display: flex;
        justify-content: space-between;
        padding: 1.2rem 1.6rem;
    }

    &:first-of-type {
        flex: 1;

        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            flex: initial;
            width: 12rem;
            margin-right: 1.6rem;
        }
    }
`;

export { DeliveryItemsGridStyled, DeliveryItemsGridWrapperStyled, DeliveryItemsGridHeadersStyled, DeliveryItemsLinkStyled, DeliveryItemsColStyled };
